module.exports = __webpack_public_path__ + "static/img/8.5cf8094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/8.jpg
// module id = J1WU
// module chunks = 0